import { Component } from '@angular/core';
import { WhiteLabelService } from '../../services/white-label.service';
import { CompanyBranding } from '../../types';

@Component({
    selector: 'gl-internet-explorer',
    templateUrl: './internet-explorer.component.html',
    styleUrls: ['./internet-explorer.component.scss'],
    standalone: false
})
export class InternetExplorerComponent {
  public whiteLabel: CompanyBranding;
  constructor(private whiteLabelService: WhiteLabelService) {
    this.whiteLabel = this.whiteLabelService.getState();
  }
}
